module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image10.f85fca9d.webp";